"use client"
import React, { useState } from 'react'
import useRatings from './useRatings'
import { IStation } from '@models'
import styles from './rating.module.scss'
import Icon from '@components/icon'
import Button from '@components/buttons/button'
import { STATION_FULL_NAME } from '@lib/helpers'

export default function Rating({station}: {station: IStation}) {
    const { ratings, vote } = useRatings(station)
    const [hoverIndex, setHoverIndex] = useState<number | null>(null)

    return (
        <div itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
            <meta itemProp="ratingValue" content={(station.votes.total / station.votes.count).toFixed(1)} />
            <meta itemProp="reviewCount" content={station.votes.count.toString()} />
            <meta itemProp="bestRating" content="5" />
            <meta itemProp="worstRating" content="1" />
            <Button className={styles.container}>
                <div className={styles.stars}>
                    {
                        new Array(5).fill(0).map((_, i) => {
                            const active = (i + 1) <= Math.ceil(ratings)
                            const hover = hoverIndex !== null && (i + 1) <= hoverIndex
                            return (
                                <span 
                                    key={i} 
                                    onClick={() => vote(i + 1)}
                                    onMouseEnter={() => setHoverIndex(i + 1)}
                                    onMouseLeave={() => setHoverIndex(null)}
                                    className={`click animated ${active && styles.active} ${hover ? styles.hover : ''}`}
                                    >
                                        <Icon icon={active ? ['fas', 'star'] : ['far', 'star']} />
                                </span>
                            )
                        })
                    }
                </div>
                <div className={`${styles.title} count animated`}>
                    <span itemProp="reviewCount">{station.votes.count}</span>
                    דירוגים
                </div>
                <div className="hide" itemProp="itemReviewed" itemScope itemType="schema.org/MediaObject"><span itemProp="name">{STATION_FULL_NAME(station.name)}</span></div>
            </Button>
        </div>
    )
}